import React from 'react'

import { Link } from 'react-router-dom'
import { Row, Col, Avatar, Divider, Card } from 'antd'

import {
  LAYOUT_REPORT_STATS_JOBS_GENERAL,
  LAYOUT_REPORT_STATS_EVOLUTION_GENERAL,
  LAYOUT_REPORT_EXPORT_LIST
} from '../navigation'

const { Meta } = Card

const ReportIcon = require('../../../assets/icons/report.png')
const StatIcon = require('../../../assets/icons/stats.png')

const Panel = (props) => (
  <>
    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_REPORT_STATS_JOBS_GENERAL}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={StatIcon} shape='square' />}
              title='Jobs'
              description='Stats'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_REPORT_STATS_EVOLUTION_GENERAL}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={StatIcon} shape='square' />}
              title='Evolution'
              description='Stats'
            />
          </Card>
        </Link>
      </Col>
    </Row>

    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_REPORT_EXPORT_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={ReportIcon} shape='square' />}
              title='Reports'
              description='Export'
            />
          </Card>
        </Link>
      </Col>
    </Row>
  </>
)

export default Panel
